import { render, staticRenderFns } from "./4mPlanInfo.vue?vue&type=template&id=4f3ca596"
import script from "./4mPlanInfo.vue?vue&type=script&lang=js"
export * from "./4mPlanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3ca596')) {
      api.createRecord('4f3ca596', component.options)
    } else {
      api.reload('4f3ca596', component.options)
    }
    module.hot.accept("./4mPlanInfo.vue?vue&type=template&id=4f3ca596", function () {
      api.rerender('4f3ca596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/plan/4mPlanInfo.vue"
export default component.exports